export const CHROMA_RIBBED_REQUEST = "CHROMA_RIBBED_REQUEST";
export const CHROMA_RIBBED_SUCCESS = "CHROMA_RIBBED_SUCCESS";
export const CHROMA_RIBBED_FAILED = "CHROMA_RIBBED_FAILED";
